import { useEffect } from 'react';
import { gaPageView } from 'ga-events/ga-main-page-view';

type TParams = {
  coordinates?: {
    loaded: boolean;
    data: GeolocationPosition | null;
  };
  userData: { customerId?: string | null; loyaltyCardNumber?: string | null };
  regionId: string | null;
  customerId: number | null;
};

export const useGAPageView = ({ userData, regionId, customerId }: TParams) => {
  useEffect(() => {
    gaPageView({
      pagePath: window.location.href,
      userId: customerId,
      loyaltyCardNumber: userData.loyaltyCardNumber,
      regionId,
      userAuth: customerId ? '1' : '0',
      clientType: customerId ? 'Авторизованный' : 'Неавторизованный',
      geo: null,
    });
  }, [userData, regionId, customerId]);
};
